module.exports = __webpack_public_path__ + "static/media/kiaservicecenter.32d9e344.jpg";